module.exports = __webpack_public_path__ + "img/users-buttons-add.0e070a64.svg";